export default __webpack_public_path__ + "static/media/youtube.f849d8d8.svg";